//apply for returning mobile users.
  $(document).ready(function () {
let isMobile = window.matchMedia("only screen and (max-width: 600px)").matches;
let returning = $(".returning-visitor").length > 0;  
if (returning == true && isMobile == true) { 
sessionStorage.setItem('formhidehp', 1);
pshideScroller();    
  }
});

  $(window).scroll(function () {
    if (sessionStorage.getItem('formhidehp')=="1"){
    pshideScroller();
    }
  });


  function hideScroller() {
    var actionbtn = $('.main-content .shopify-section:nth-of-type(5) ');
    var sub = $('#ps__widget_container');
    actionfromtop = actionbtn.offset().top + 300;
    subfromtop = $(window).scrollTop() + $(window).height();

    if (actionfromtop > subfromtop) { sub.hide(); }
    else { sub.show(); }
  }

  function pshideScroller() {
    var actionbtn = $('.main-content .shopify-section:nth-of-type(5) ');
    var sub = $('#ps__widget_container');
    actionfromtop = actionbtn.offset().top + 300;
    subfromtop = $(window).scrollTop() + $(window).height();

    if (actionfromtop > subfromtop) { sub.hide(); }
    else { sub.show(); }
  }